import Marquee from "react-fast-marquee";

const LOGOS = [
  { src: "/img/logo_cpc_full.png", alt: "Cessna Pilot Center" },
  { src: "/img/logo_garmin.png", alt: "Garmin" },
  { src: "/img/logo_pilot360.png", alt: "Pilot-360" },
  { src: "/img/logo_evionica.jpg", alt: "Evionica" },
  { src: "/img/logo_flightlogger_badge.png", alt: "FlightLogger" },
];

export const PartnerMarquee = ({ dark = false }) => (
  <section className={`py-14 lg:py-16 ${dark ? "bg-navy-2" : "bg-white"} border-y ${dark ? "border-white/10" : "border-[var(--line)]"}`} data-testid="partner-marquee">
    <p className={`text-center overline mb-8 ${dark ? "text-accent-2" : "text-grey"}`}>Trusted partners & accreditations</p>
    <Marquee speed={45} gradient gradientColor={dark ? "#0f3159" : "#ffffff"} gradientWidth={100} pauseOnHover autoFill>
      {LOGOS.map((l, i) => (
        <div key={i} className="mx-4 h-24 w-44 rounded-2xl bg-white border border-[var(--line)] card-shadow flex items-center justify-center p-4">
          <img src={l.src} alt={l.alt} className="max-h-16 max-w-full object-contain" loading="lazy" />
        </div>
      ))}
    </Marquee>
  </section>
);
